"use strict";
Object.defineProperty(exports, "__esModule", { value: !0 }), (exports.validateKey = exports.getKey = void 0);
const api_1 = require("./api");
let API_KEY = "";
const getKey = () => API_KEY || "";
exports.getKey = getKey;
const ATTEMPTS = 5,
    TIMEOUT = 3e3,
    NO_KEY_MESSAGE = "Polotno API is initialized without API key. It may lead to unexpected behavior and stop working. Please create API key here: https://polotno.dev/cabinet",
    NO_VALID_MESSAGE = "Polotno API key is not valid. Please get new API key here: https://polotno.dev/cabinet",
    ERROR_MESSAGE = "Can not validate Polotno API key. Please report to anton@polotno.dev immediately.",
    NOT_PAID_MESSAGE = "%cPolotno Free Version. Development or non-commercial usage only. https://polotno.dev/",
    BAD_DOMAIN_MESSAGE = `%cPolotno error! Current domain is not allowed. It may lead to unexpected behavior and stop working. Please add "${location.origin}" here: https://polotno.dev/cabinet`,
    isPolotnoNode = navigator.userAgent.indexOf("HeadlessChrome") >= 0;
async function validateKey(e) {
    console.log("BK")
}
exports.validateKey = validateKey;
